/* globals I18n */
import React from 'react';
import trackClick from 'Utils/trackClick';

export const clickableAddress = (street, city, state) => {
  const query = encodeURI([street, city, state].join(' '));
  const uri = `https://www.google.com/maps/search/?api=1&query=${query}`;

  return (
    <div className="mb-2">
      <a href={uri} target="_blank" className="text-brand-blue underline text-md leading-snug" onClick={() => trackClick({ event_action: 'service center address', event_label: [street, city, state] })}>
        <p>{street}</p>
        <p>{city}, {state}</p>
      </a>
    </div>
  );
};

export const formatUrl = (urlString = '') => {
  if (urlString === null) return {};

  if (urlString.startsWith('http')) {
    return {
      url: urlString,
      displayUrl: urlString.split('//')[1].replace('www.', '')
    };
  }

  return {
    url: `http://${urlString}`,
    displayUrl: urlString.replace('www.', '')
  };
}

export const getDesc = (shopsCount, query = '', radius) => {
  let base = `${shopsCount} TechNet Service Centers ${I18n.t('within_radius', { radius })}`;

  if (query) base += ` ${query}`;

  return base;
}
